import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { AccountabilityComponent } from './accountability/accountability.component';
import { LegislationComponent } from './legislation/legislation.component';
import { MeetingScheduleComponent } from './meeting-schedule/meeting-schedule.component';
import { ScreenGuard } from './shared/guards/screen.guard';
import { LegislationListComponent } from './legislation/legislation-list/legislation-list.component';

const routes: Routes = [
  
  { path: 'inicio', 
    component: HomeComponent },
  {
    path: 'prestacao-contas',
    component: AccountabilityComponent,
    canActivate: [ScreenGuard],
  },
  {
    path: 'legislacao',
    component: LegislationComponent,
    canActivate: [ScreenGuard],
  },
  { path: 'listagem-legislacao', component: LegislationListComponent },
  {
    path: 'calendario-reunioes',
    component: MeetingScheduleComponent,
    canActivate: [ScreenGuard],
  },
  {
    path: 'termos-politicas',
    loadChildren: () =>
      import('./termos-politicas/termos-politicas.module').then(
        (m) => m.TermosPoliticasModule
      ),
  },
  { path: 'listagem-legislacao', redirectTo: 'inicio', pathMatch: 'full'},
  { path: '**', redirectTo: 'inicio', pathMatch: 'full' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      anchorScrolling: 'enabled',
      useHash: true,
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
